import React from 'react';
import '../App.css';
import logo from './../assets/DAKLabb-logo-black.png';
import liLogo from './../assets/linkedin.png';
import ghLogo from './../assets/github.png';

export default function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          <img src={logo} alt="DAKLabb Logo" className="App-logo"></img>
          <br/><a href="./About">About Me</a>
          <br/>
          <a href="https://www.linkedin.com/in/davidakonigsberg"><img src={liLogo} alt="David's LinkedIn Profile"
                                                                      className="external-logo-link"></img></a>
          <a href="https://github.com/davidkonigsberg"><img src={ghLogo} alt="David's GitHub Profile"
                                                            className="external-logo-link"></img></a>
        </p>
        <br/>
      </header>
    </div>
  );
}
